import type { ComponentProps } from 'react';
import type React from 'react';

import { Text } from '@change/ds-core-ui';
import { FlagTransparentIcon } from '@change/ds-icons';

import { Translate } from '@change-corgi/core-react/i18n';

import { ReportAbuseLinkContainer as ReportAbuseLink } from '../../containers/ReportAbuseLink';

type Props = ComponentProps<typeof ReportAbuseLink>;

export const ReportAIIssueLink: React.FC<Props> = (props) => {
	return (
		<ReportAbuseLink {...props}>
			{/* NOT wrapped in <FocusRing>: ReportAbuseLink clones this element directly to inject its
			    onClick (see ReportAbuseLinkContainer). FocusRing's own cloneElement only forwards
			    focusProps/className to its child, not arbitrary props injected on FocusRing itself by
			    an ancestor, so nesting it here would silently drop the click handler. Manual
			    focus-visible classes are kept as the working alternative. */}
			<button
				type="button"
				className="text-typography-weak focus-visible:outline-stroke-focus m-0 mb-4 flex cursor-pointer items-center border-0 bg-transparent p-0 focus-visible:rounded-sm focus-visible:outline-2 focus-visible:outline-offset-2"
			>
				<FlagTransparentIcon size={16} className="mr-1" />
				<Text as="span" size="x-small" underline>
					<Translate value="fe.pages.decision_maker_show.ai_content.report_issue_label" />
				</Text>
			</button>
		</ReportAbuseLink>
	);
};
